export default {
  login({ commit }, data) {
    commit('setUserInfo', data);
  },
  logout({ commit }) {
    commit('setUserInfo', null);
  },
}